import React from "react";

export default function InPharmacyIcon(props) {
  return (
    <svg width={28} height={22} viewBox="0 0 28 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="9.43945" y="0.75" width="9.12069" height="19.7414" stroke="#2B56A3" strokeWidth="1.5" />
      <rect x="19.0947" y="8.47412" width="8.15517" height="12.0172" stroke="#2B56A3" strokeWidth="1.5" />
      <rect x="0.75" y="8.47412" width="8.15517" height="12.0172" stroke="#2B56A3" strokeWidth="1.5" />
      <path
        d="M13.9997 2.89648V5.31028M13.9997 7.72407V5.31028M13.9997 5.31028H16.4135M13.9997 5.31028H11.5859"
        stroke="#CA367E"
        strokeWidth="1.5"
      />
      <rect x="12.0859" y="15.9482" width="3.82759" height="4.7931" stroke="#2B56A3" />
      <rect x="21.25" y="11.25" width="3.5" height="0.5" stroke="#2B56A3" strokeWidth="0.5" />
      <rect x="3.25" y="11.25" width="3.5" height="0.5" stroke="#2B56A3" strokeWidth="0.5" />
      <rect x="21.25" y="14.25" width="3.5" height="0.5" stroke="#2B56A3" strokeWidth="0.5" />
      <rect x="3.25" y="14.25" width="3.5" height="0.5" stroke="#2B56A3" strokeWidth="0.5" />
    </svg>
  );
}
